var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonIconClient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14968_12311)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.7344,
    y: 28.7344,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9375 62.9492C49.8227 62.9492 48.7537 63.392 47.9654 64.1803C47.1772 64.9685 46.7344 66.0376 46.7344 67.1523V67.7528C46.7344 70.6265 48.5633 73.0571 51.1596 74.7095C53.7704 76.3715 57.3046 77.3599 61.145 77.3599C64.9855 77.3599 68.5185 76.3715 71.1304 74.7107C73.7267 73.0583 75.5557 70.6277 75.5557 67.7528V67.1523C75.5557 66.0376 75.1128 64.9685 74.3246 64.1803C73.5364 63.392 72.4673 62.9492 71.3526 62.9492H50.9375Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9375 62.9492C49.8227 62.9492 48.7537 63.392 47.9654 64.1803C47.1772 64.9685 46.7344 66.0376 46.7344 67.1523V67.7528C46.7344 70.6265 48.5633 73.0571 51.1596 74.7095C53.7704 76.3715 57.3046 77.3599 61.145 77.3599C64.9855 77.3599 68.5185 76.3715 71.1304 74.7107C73.7267 73.0583 75.5557 70.6277 75.5557 67.7528V67.1523C75.5557 66.0376 75.1128 64.9685 74.3246 64.1803C73.5364 63.392 72.4673 62.9492 71.3526 62.9492H50.9375Z",
    fill: "url(#paint0_linear_14968_12311)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9375 62.9492C49.8227 62.9492 48.7537 63.392 47.9654 64.1803C47.1772 64.9685 46.7344 66.0376 46.7344 67.1523V67.7528C46.7344 70.6265 48.5633 73.0571 51.1596 74.7095C53.7704 76.3715 57.3046 77.3599 61.145 77.3599C64.9855 77.3599 68.5185 76.3715 71.1304 74.7107C73.7267 73.0583 75.5557 70.6277 75.5557 67.7528V67.1523C75.5557 66.0376 75.1128 64.9685 74.3246 64.1803C73.5364 63.392 72.4673 62.9492 71.3526 62.9492H50.9375Z",
    fill: "url(#paint1_linear_14968_12311)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1435 60.5468C63.373 60.5468 65.5111 59.6611 67.0876 58.0847C68.6641 56.5082 69.5497 54.37 69.5497 52.1406C69.5497 49.9111 68.6641 47.773 67.0876 46.1965C65.5111 44.62 63.373 43.7344 61.1435 43.7344C58.914 43.7344 56.7759 44.62 55.1994 46.1965C53.623 47.773 52.7373 49.9111 52.7373 52.1406C52.7373 54.37 53.623 56.5082 55.1994 58.0847C56.7759 59.6611 58.914 60.5468 61.1435 60.5468Z",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1435 60.5468C63.373 60.5468 65.5111 59.6611 67.0876 58.0847C68.6641 56.5082 69.5497 54.37 69.5497 52.1406C69.5497 49.9111 68.6641 47.773 67.0876 46.1965C65.5111 44.62 63.373 43.7344 61.1435 43.7344C58.914 43.7344 56.7759 44.62 55.1994 46.1965C53.623 47.773 52.7373 49.9111 52.7373 52.1406C52.7373 54.37 53.623 56.5082 55.1994 58.0847C56.7759 59.6611 58.914 60.5468 61.1435 60.5468Z",
    fill: "url(#paint2_linear_14968_12311)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14968_12311",
    x: -0.00031662,
    y: -0.00031662,
    width: 121.469,
    height: 121.469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.3673
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14968_12311"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14968_12311",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14968_12311",
    x1: 53.5878,
    y1: 64.8646,
    x2: 58.2437,
    y2: 79.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#9C6CFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A41DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14968_12311",
    x1: 61.145,
    y1: 61.2332,
    x2: 67.6646,
    y2: 85.5943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#885EDB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E362F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14968_12311",
    x1: 56.7351,
    y1: 45.9692,
    x2: 65.3034,
    y2: 59.6509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#9C6CFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A41DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIconClient);
export default __webpack_public_path__ + "static/media/personIconClient.7377f06c4c8bd43bd3b5c501ad5153e1.svg";
export { ForwardRef as ReactComponent };